import { Document } from '@contentful/rich-text-types';

/** Extracts a flat plain-text string from a Contentful rich text Document. */
export function extractPlainText(doc: Document | undefined | null): string {
  if (!doc?.content) return '';
  return doc.content
    .flatMap((block) => block.content ?? [])
    .map((node) =>
      node.nodeType === 'text'
        ? (node as unknown as { value: string }).value
        : '',
    )
    .join('');
}
